import React, { useState } from 'react';
import {
    IconMoreVerticalDots,
    DocumentPlus, IconDocumentation,
    IconPersonPhoto
} from '../../../../components/buttons/IconButtons';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import TableFunction from '../../../../components/table/TableFunction';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODEL } from '../../../../components/table/Model/TableModel';
import { useDispatch } from 'react-redux';
import {SimpleSearchWithId} from "../../../../reduxToolkit/Search/SearchApi";
import {USER_LIST_MODEL} from "../Model/Models";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import routes from '../../../../Routes/routes';
import {VIEW_TYPE} from "../../../../enums/ViewType";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EmployeeSectionApp = ({ contractorId, model, supplierId }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [selected, setSelected] = useState(null);
    const [selectedList, setSelectedList] = useState([]);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [showDocumentationModal, setShowDocumentationModal] = useState(false); // Controls documentation modal visibility
    const [showAccessLogModal, setShowAccessLogModal] = useState(false);
    const searchId = 'txt_esa_search_documentation_employee';
    const [results, setResults] = useState({content: [], totalElements: 0}); // Stores API results list
    const { t } = useTranslation();
    const { id } = useParams();

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model, key: searchElement, userId: contractorId || supplierId});
        dispatch(SimpleSearchWithId({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success === true) {
                setData(data);
            }
        });
    };

    // Table helper with pagination and menu handling
    const { handleMenuToggle, handleClose, openMenu, page, rowsPerPage, pagination } = TableFunction({
        selectedList,
        setSelectedList,
        labelRowsPerPage: 'employees_per_page',
        data: results,
        hasContainer: true,
        fixedPagination: false,
        view: VIEW_TYPE.GRID.name,
        searchElement, //New
        getData//New
    });

    const setData = (data) => {
        setResults({
            content: data?.content?.map((e) => USER_LIST_MODEL.toSet(e)),
            totalElements: data?.totalElements,
        });
    };

    const handleIdentityValidationNavigation = (itemId) => {
        const isSupplier = Boolean(supplierId);
        navigate(
            (isSupplier ? routes.employee.suppliersIdentityValidation : routes.employee.contractorIdentityValidation) +
                itemId,
            {
                state: {
                    backUrl: (isSupplier ? routes.employee.suppliersDetails : routes.employee.details) + id,
                    currentTab: location.state?.currentTab,
                },
            },
        );
    };

    //get action buttons
    const getActionsButtons = (item, index) => {
        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
                icon={<IconMoreVerticalDots />}
            >
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t('documentation')}
                    icon={<IconDocumentation />}
                    click={() => {
                        setSelected(item);
                        setShowDocumentationModal(true);
                    }}
                />
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t('access_log')}
                    icon={<DocumentPlus />}
                    click={() => {
                        setSelected(item);
                        setShowAccessLogModal(true);
                    }}
                />
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t('validation_identity')}
                    icon={<IconPersonPhoto />}
                    click={() => handleIdentityValidationNavigation(item?.id)}
                />
            </DropDownMenuProfile>
        );
    };

    return {
        t,
        selected,
        setSelected,
        searchId,
        results,
        searchElement,
        setSearchElement,
        setSearch,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        showDocumentationModal,
        setShowDocumentationModal,
        showAccessLogModal,
        setShowAccessLogModal,
        setData,
        getActionsButtons,
        pagination,
    };
};

export default EmployeeSectionApp;
